import { useTranslation } from 'react-i18next';

export const StatementsTable = ({ statements }) => {
    const { t } = useTranslation();

    return (
        <table className="min-w-full border-b border-gray-100">
            <thead className="">
                <tr>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Date')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Type')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Chain')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-sm font-medium text-gray-500 tracking-wider">
                        {t('Download')}
                    </th>
                </tr>
            </thead>
            <tbody className="bg-white">
                {statements.map((statement) => (
                    <tr key={statement.link} className="odd:bg-gray-50">
                        <td className="px-6 py-2 whitespace-nowrap">
                            <div className="flex items-center">
                                {(statement.from || statement.to) && (
                                    <>
                                        {statement.from && <span>{statement.from}&nbsp;</span>}
                                        {statement.to && <span> {statement.from ? `- ${statement.to}` : statement.to}</span>}
                                    </>
                                )}
                                {statement.month && <span className="capitalize">{statement.month} &nbsp;</span>}
                                {statement.year && <span> {statement.year}</span>}
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">{statement.type}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{statement.name || t('All')}</td>
                        <td className="px-6 py-4 text-right whitespace-nowrap">
                            <a href={statement.link} download>
                                {t('Download')}
                            </a>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
